/* eslint-disable react/no-unescaped-entities */
import { useRouter } from "next/router";
import React, { useState } from "react";
import {
  MdLabelOutline,
  MdOutlineAnnouncement,
  MdOutlineAssignmentReturned,
  MdSettingsInputComponent,
} from "react-icons/md";
import { BsArrowRightCircle } from "react-icons/bs";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
} from "reactstrap";
import Link from "next/link";
import Image from "next/image";

import { aboutUs } from "@/utils/content";
import {
  aboutLogoIllustration,
  aboutPartnersImage,
  aboutUsImg1,
  aboutUsImg4,
} from "@/utils/images";
import { routes } from "@/utils/routes";
import classes from "@/styles/about/about-main.module.css";

const AboutMain = () => {
  const content = aboutUs.en;
  const history = useRouter();
  const [open, setOpen] = useState("1");
  const handleNavigation = (href: string) => {
    const link = document.getElementById(href);
    if (link) {
      window.scrollTo({ top: link.offsetTop - 50, behavior: "smooth" });
    }
  };

  //@ts-ignore
  const toggle = (id) => {
    if (open === id) {
      //@ts-ignore
      setOpen();
    } else {
      setOpen(id);
    }
  };

  return (
    <main className={classes.container}>
      <section className={`${classes.heroImg} position-relative`}>
        <div
          className={`container position-absolute text-white ${classes.heroContent}`}
        >
          <h1>{content.bannerTitle}</h1>
          <p>
            <strong>Shipvista.com</strong> {content.bannerSubTitle}
          </p>
        </div>
      </section>
      <Nav className={`${classes.nav}`}>
        <NavItem>
          <NavLink
            className={classes.navLink}
            active
            onClick={() => handleNavigation("product")}
          >
            {content.link1}{" "}
            <BsArrowRightCircle className={classes.navLinkIco} />
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classes.navLink}
            active
            onClick={() => handleNavigation("partners")}
          >
            {content.link2}{" "}
            <BsArrowRightCircle className={classes.navLinkIco} />
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classes.navLink}
            active
            onClick={() => handleNavigation("benefits")}
          >
            {content.link3}{" "}
            <BsArrowRightCircle className={classes.navLinkIco} />
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classes.navLink}
            active
            onClick={() => handleNavigation("faq")}
          >
            {content.link4}{" "}
            <BsArrowRightCircle className={classes.navLinkIco} />
          </NavLink>
        </NavItem>
      </Nav>
      <Container>
        <section className="my-5" id="product">
          <Row>
            <Col className="mb-3" xs={12} lg={6}>
              <div>
                <h4>{content.section1Title}</h4>
                <p>{content.section1Para1}</p>
                <p>{content.section1Para2}</p>
                <Button
                  className={classes.btn1}
                  onClick={() => history.push(routes.register)}
                >
                  {content.section1Btn}
                </Button>
              </div>
            </Col>
            <Col
              className="d-flex justify-content-center align-items-center"
              xs={12}
              lg={6}
            >
              <Image
                className={`${classes.img2} img-fluid`}
                src={aboutLogoIllustration}
                alt="logo illustration"
                height={400}
                width={400}
              />
            </Col>
          </Row>
        </section>
        <section id="retailers">
          <Row>
            <Col xs={12} lg={6}>
              <div>
                <h5> {content.section2Title}</h5>
                <div className={`${classes.bordered} mt-3`}>
                  <div
                    className={`d-flex p-2 ${classes.borderCard} ${classes.borderCardTop}`}
                  >
                    <MdSettingsInputComponent
                      className="ms-2 me-2 mt-2 text-secondary"
                      size={30}
                    />
                    <div className="ms-2 text-secondary">
                      <h6 className="pt-2">{content.section2Title1}</h6>
                      <p>{content.section2Para1}</p>
                    </div>
                  </div>
                  <div className={`d-flex p-2 ${classes.borderCard}`}>
                    <MdLabelOutline
                      className="ms-2 me-2 mt-2 text-secondary"
                      size={20}
                    />
                    <div className="ms-2 text-secondary">
                      <h6 className="pt-2">{content.section2Title2}</h6>
                      <p>{content.section2Para2}</p>
                    </div>
                  </div>
                  <div className={`d-flex p-2 ${classes.borderCard}`}>
                    <MdOutlineAnnouncement
                      className="ms-2 me-2 mt-2 text-secondary"
                      size={20}
                    />
                    <div className="ms-2 text-secondary">
                      <h6 className="pt-2">{content.section2Title3}</h6>
                      <p>{content.section2Para3}</p>
                    </div>
                  </div>
                  <div
                    className={`d-flex p-2 ${classes.borderCard} ${classes.borderCardBottom}`}
                  >
                    <MdOutlineAssignmentReturned
                      className="ms-2 me-2 mt-2 text-secondary"
                      size={20}
                    />
                    <div className="ms-2 text-secondary">
                      <h6 className="pt-2">{content.section2Title4}</h6>
                      <p>{content.section2Para4}</p>
                    </div>
                  </div>
                </div>
                <p className="mt-3">{content.section2Para5}</p>
              </div>
            </Col>
            <Col xs={12} lg={6}>
              <div className="w-75 h-100 mx-auto d-flex align-items-center justify-content-center">
                <div>
                  <h4>{content.section2Title5}</h4>
                  <p>{content.section2Para6}</p>
                  <p>{content.section2Para7}</p>
                </div>
              </div>
            </Col>
          </Row>
        </section>
        <section id="partners">
          <Row>
            <Col className="mb-3" xs={12} lg={6}>
              <div
                className={`d-flex h-100 justify-content-center align-items-center`}
              >
                <div>
                  <h4>{content.section3Title1}</h4>
                  <p>{content.section3Para1}</p>
                </div>
              </div>
            </Col>
            <Col
              className="d-flex justify-content-center align-items-center mb-3"
              xs={12}
              lg={6}
            >
              <Image
                className={`${classes.img3} img-fluid`}
                src={aboutPartnersImage}
                alt="logo illustration"
                height={400}
                width={450}
              />
            </Col>
          </Row>
        </section>
        <section id="benefits">
          <div className={` container`}>
            <div>
              <h4>{content.section4Title1}</h4>
              <ul>
                {content.section4List.map((l, i) => (
                  <li key={i}>{l}</li>
                ))}
              </ul>
            </div>
          </div>
        </section>
        <section className="my-5" id="faq">
          <Row>
            <Col sm={3}>
              <h2>{content.faqTitle}</h2>
              <p>{content.section5Para1}</p>
              <p>
                {content.section5Para2}{" "}
                <a href="mailto:customercare@shipvista.com">
                  {" "}
                  {content.section5Link}
                </a>
              </p>
            </Col>
            <Col xs={12} lg={9}>
              {/*@ts-ignore*/}
              <Accordion open={open} toggle={toggle}>
                {content.section5List?.map((f, i) => {
                  return (
                    <AccordionItem key={i}>
                      <AccordionHeader targetId={(i + 1).toString()}>
                        {f.question}
                      </AccordionHeader>
                      <AccordionBody accordionId={(i + 1).toString()}>
                        <p>{f.answer}</p>
                      </AccordionBody>
                    </AccordionItem>
                  );
                })}
              </Accordion>
            </Col>
          </Row>
        </section>
      </Container>
      <section className="my-5 py-5">
        <Image
          className={`${classes.footerImage}  img-fluid`}
          src={aboutUsImg4}
          alt="bottom background art"
          height={250}
          width={1515}
        />
        <Container>
          <Row>
            <Col className="mb-3" xs={12} md={4}>
              <Card className={classes.footerCard}>
                <CardBody>
                  <div>
                    <h6>{content.section6Cards[0].title}</h6>
                    <p>{content.section6Cards[0].para}</p>
                  </div>
                  <Link href={routes.howItWorks}>
                    {content.section6Cards[0].link}
                  </Link>
                </CardBody>
              </Card>
            </Col>
            <Col className="mb-3" xs={12} md={4}>
              <Card className={classes.footerCard}>
                <CardBody>
                  <div>
                    <h6>{content.section6Cards[1].title}</h6>
                    <p>{content.section6Cards[1].para}</p>
                  </div>
                  <Link href={routes.contactSales}>
                    {content.section6Cards[1].link}
                  </Link>
                </CardBody>
              </Card>
            </Col>
            <Col className="mb-3" xs={12} md={4}>
              <Card className={classes.footerCard}>
                <CardBody>
                  <div>
                    <h6>{content.section6Cards[2].title}</h6>
                    <p>{content.section6Cards[2].para}</p>
                  </div>
                  <Link href={routes.blog}>
                    {content.section6Cards[2].link}
                  </Link>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};

export default AboutMain;
